import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBilderitLogoHzColorCroppedDarkmode = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "12 15 240 70",
	xmlSpace: "preserve",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("linearGradient", {
				id: "a",
				children: /* @__PURE__ */ _jsx("stop", {
					stopColor: "#fff",
					offset: 0
				})
			}),
			/* @__PURE__ */ _jsx("linearGradient", {
				id: "i",
				x1: 88.616,
				x2: 116.06,
				y1: 50.998,
				y2: 50.998,
				gradientUnits: "userSpaceOnUse",
				xlinkHref: "#a"
			}),
			/* @__PURE__ */ _jsx("linearGradient", {
				id: "h",
				x1: 120.19,
				x2: 126.27,
				y1: 51.39,
				y2: 51.39,
				gradientUnits: "userSpaceOnUse",
				xlinkHref: "#a"
			}),
			/* @__PURE__ */ _jsx("linearGradient", {
				id: "g",
				x1: 131.85,
				x2: 142.26,
				y1: 50.998,
				y2: 50.998,
				gradientUnits: "userSpaceOnUse",
				xlinkHref: "#a"
			}),
			/* @__PURE__ */ _jsx("linearGradient", {
				id: "f",
				x1: 142.28,
				x2: 169.38,
				y1: 51.096,
				y2: 51.096,
				gradientUnits: "userSpaceOnUse",
				xlinkHref: "#a"
			}),
			/* @__PURE__ */ _jsx("linearGradient", {
				id: "e",
				x1: 172.58,
				x2: 197.96,
				y1: 56.742,
				y2: 56.742,
				gradientUnits: "userSpaceOnUse",
				xlinkHref: "#a"
			}),
			/* @__PURE__ */ _jsx("linearGradient", {
				id: "d",
				x1: 201.5,
				x2: 219.52,
				y1: 56.595,
				y2: 56.595,
				gradientUnits: "userSpaceOnUse",
				xlinkHref: "#a"
			}),
			/* @__PURE__ */ _jsx("linearGradient", {
				id: "c",
				x1: 221.92,
				x2: 228.01,
				y1: 51.39,
				y2: 51.39,
				gradientUnits: "userSpaceOnUse",
				xlinkHref: "#a"
			}),
			/* @__PURE__ */ _jsx("linearGradient", {
				id: "b",
				x1: 231.13,
				x2: 248.11,
				y1: 52.471,
				y2: 52.471,
				gradientUnits: "userSpaceOnUse",
				xlinkHref: "#a"
			})
		] }),
		/* @__PURE__ */ _jsx("path", {
			d: "m91.022 70.171c-0.687 0-1.26-0.223-1.718-0.663-0.459-0.442-0.688-1.007-0.688-1.694v-33.631c0-0.688 0.222-1.252 0.664-1.695 0.441-0.44 1.006-0.663 1.693-0.663h11.784c2.127 0 4.017 0.428 5.67 1.277 1.653 0.851 2.962 2.03 3.928 3.536 0.965 1.505 1.448 3.239 1.448 5.204 0 1.669-0.45 3.167-1.35 4.492-0.901 1.324-2.103 2.349-3.609 3.068 2.161 0.557 3.904 1.62 5.229 3.191 1.326 1.571 1.989 3.602 1.989 6.088 0 2.226-0.524 4.206-1.571 5.941-1.048 1.734-2.504 3.093-4.37 4.074-1.865 0.982-3.994 1.474-6.382 1.474h-12.717zm2.259-22.487h9.476c1.898 0 3.461-0.49 4.688-1.473 1.228-0.981 1.841-2.438 1.841-4.369 0-1.898-0.613-3.314-1.841-4.247-1.227-0.934-2.79-1.399-4.688-1.399h-9.476v11.488zm0 18.117h10.458c1.504 0 2.847-0.277 4.025-0.835 1.179-0.557 2.095-1.366 2.75-2.431 0.654-1.063 0.982-2.348 0.982-3.854 0-1.44-0.328-2.652-0.982-3.633-0.655-0.982-1.571-1.728-2.75-2.234-1.178-0.507-2.521-0.761-4.025-0.761h-10.458v13.748z",
			fill: "url(#i)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m123.23 38.698c-0.818 0-1.53-0.301-2.136-0.907-0.606-0.605-0.908-1.317-0.908-2.137 0-0.883 0.302-1.61 0.908-2.184 0.606-0.572 1.318-0.86 2.136-0.86s1.53 0.288 2.136 0.86c0.605 0.573 0.908 1.301 0.908 2.184 0 0.819-0.294 1.531-0.884 2.137-0.589 0.606-1.308 0.907-2.16 0.907m0 31.473c-0.687 0-1.244-0.213-1.669-0.639-0.426-0.425-0.639-0.981-0.639-1.67v-22.24c0-0.688 0.213-1.243 0.639-1.67 0.425-0.426 0.982-0.638 1.669-0.638s1.244 0.212 1.669 0.638c0.425 0.427 0.639 0.982 0.639 1.67v22.24c0 0.688-0.214 1.245-0.639 1.67-0.424 0.426-0.982 0.639-1.669 0.639",
			fill: "url(#h)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m139.02 70.171c-1.408 0-2.651-0.385-3.731-1.154-1.081-0.769-1.924-1.816-2.529-3.143-0.606-1.325-0.908-2.854-0.908-4.59v-27.2c0-0.688 0.204-1.235 0.613-1.645s0.958-0.614 1.645-0.614c0.688 0 1.236 0.204 1.645 0.614 0.409 0.409 0.614 0.957 0.614 1.645v27.2c0 1.276 0.245 2.324 0.736 3.142s1.129 1.227 1.915 1.227h1.228c0.621 0 1.112 0.206 1.473 0.615 0.359 0.409 0.54 0.957 0.54 1.645s-0.279 1.236-0.835 1.645c-0.557 0.41-1.26 0.614-2.112 0.614h-0.294z",
			fill: "url(#g)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m155.83 70.367c-2.553 0-4.853-0.598-6.898-1.792-2.046-1.194-3.666-2.823-4.861-4.887-1.195-2.061-1.792-4.385-1.792-6.971 0-2.585 0.556-4.902 1.67-6.947 1.112-2.045 2.634-3.666 4.566-4.86 1.931-1.194 4.107-1.792 6.529-1.792 2.03 0 3.887 0.417 5.573 1.252 1.685 0.835 3.068 1.972 4.149 3.412v-13.649c0-0.687 0.221-1.243 0.663-1.669 0.442-0.425 0.989-0.639 1.644-0.639 0.688 0 1.244 0.214 1.67 0.639 0.425 0.426 0.638 0.982 0.638 1.669v22.634c0 2.587-0.597 4.91-1.792 6.973-1.195 2.062-2.816 3.682-4.861 4.86-2.046 1.178-4.345 1.767-6.898 1.767m0-4.075c1.768 0 3.33-0.418 4.689-1.252 1.358-0.835 2.438-1.98 3.24-3.437 0.802-1.458 1.203-3.085 1.203-4.886 0-1.832-0.401-3.461-1.203-4.885s-1.882-2.553-3.24-3.389c-1.359-0.835-2.921-1.252-4.689-1.252-1.702 0-3.249 0.417-4.64 1.252-1.391 0.836-2.487 1.965-3.289 3.389s-1.203 3.053-1.203 4.885c0 1.801 0.401 3.428 1.203 4.886 0.802 1.456 1.898 2.602 3.289 3.437 1.391 0.834 2.938 1.252 4.64 1.252",
			fill: "url(#f)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m186.42 70.367c-2.684 0-5.073-0.581-7.167-1.743-2.096-1.161-3.732-2.766-4.911-4.813-1.178-2.045-1.767-4.394-1.767-7.046 0-2.683 0.556-5.047 1.669-7.093s2.659-3.649 4.64-4.812c1.98-1.162 4.246-1.743 6.8-1.743 2.52 0 4.705 0.563 6.554 1.692 1.849 1.131 3.265 2.686 4.247 4.665 0.982 1.981 1.474 4.265 1.474 6.85 0 0.589-0.197 1.072-0.59 1.448-0.393 0.377-0.9 0.564-1.522 0.564h-20.13v-3.683h20.179l-2.062 1.424c0-1.734-0.328-3.28-0.982-4.64-0.655-1.357-1.588-2.43-2.798-3.216-1.212-0.785-2.669-1.178-4.37-1.178-1.866 0-3.478 0.417-4.836 1.252-1.359 0.835-2.39 1.988-3.093 3.461-0.705 1.473-1.056 3.143-1.056 5.007 0 1.867 0.417 3.528 1.252 4.984 0.834 1.457 1.98 2.602 3.437 3.437 1.456 0.835 3.134 1.253 5.032 1.253 1.081 0 2.168-0.196 3.265-0.59 1.097-0.393 1.989-0.851 2.676-1.375 0.458-0.326 0.949-0.499 1.473-0.515 0.523-0.017 0.982 0.139 1.375 0.466 0.523 0.459 0.802 0.958 0.835 1.498 0.031 0.54-0.214 1.005-0.737 1.399-1.08 0.884-2.455 1.611-4.124 2.185-1.669 0.576-3.258 0.862-4.763 0.862",
			fill: "url(#e)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m203.75 70.17c-0.72 0-1.276-0.188-1.669-0.563s-0.589-0.941-0.589-1.694v-22.34c0-0.72 0.196-1.277 0.589-1.67s0.949-0.589 1.669-0.589c0.753 0 1.318 0.188 1.694 0.563 0.376 0.377 0.565 0.942 0.565 1.695v22.339c0 0.72-0.189 1.276-0.565 1.669-0.376 0.395-0.941 0.59-1.694 0.59m-0.147-16.692c0.032-1.996 0.532-3.78 1.498-5.353 0.965-1.57 2.258-2.813 3.878-3.73 1.62-0.916 3.395-1.375 5.327-1.375 1.799 0 3.158 0.287 4.076 0.858 0.915 0.574 1.275 1.286 1.079 2.137-0.131 0.459-0.336 0.803-0.614 1.03-0.278 0.23-0.613 0.361-1.006 0.394s-0.819 0-1.277-0.099c-2.029-0.326-3.837-0.277-5.424 0.147-1.589 0.426-2.84 1.146-3.756 2.161-0.917 1.015-1.375 2.291-1.375 3.829h-2.406z",
			fill: "url(#d)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m224.96 38.698c-0.819 0-1.531-0.301-2.136-0.907-0.606-0.605-0.908-1.317-0.908-2.137 0-0.883 0.302-1.61 0.908-2.184 0.605-0.572 1.317-0.86 2.136-0.86 0.818 0 1.529 0.288 2.135 0.86 0.605 0.573 0.908 1.301 0.908 2.184 0 0.819-0.294 1.531-0.883 2.137s-1.309 0.907-2.16 0.907m0 31.473c-0.687 0-1.245-0.213-1.67-0.639-0.425-0.425-0.638-0.981-0.638-1.67v-22.24c0-0.688 0.213-1.243 0.638-1.67 0.425-0.426 0.983-0.638 1.67-0.638s1.243 0.212 1.669 0.638c0.425 0.427 0.639 0.982 0.639 1.67v22.24c0 0.688-0.214 1.245-0.639 1.67-0.425 0.426-0.982 0.639-1.669 0.639",
			fill: "url(#c)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m233.24 48.225c-0.622 0-1.129-0.188-1.521-0.565-0.393-0.375-0.59-0.826-0.59-1.35 0-0.622 0.197-1.113 0.59-1.474 0.392-0.359 0.899-0.539 1.521-0.539h11.735c0.621 0 1.129 0.18 1.522 0.539 0.393 0.36 0.589 0.852 0.589 1.474 0 0.523-0.196 0.975-0.589 1.35-0.393 0.377-0.901 0.565-1.522 0.565h-11.735zm11.342 21.946c-1.669 0-3.167-0.418-4.492-1.252-1.326-0.835-2.374-1.964-3.143-3.389-0.769-1.423-1.154-3.051-1.154-4.885v-23.616c0-0.653 0.213-1.193 0.639-1.619 0.425-0.427 0.965-0.639 1.62-0.639 0.688 0 1.243 0.212 1.669 0.639 0.425 0.426 0.638 0.966 0.638 1.619v23.616c0 1.44 0.401 2.635 1.204 3.584 0.801 0.95 1.808 1.423 3.019 1.423h1.571c0.556 0 1.022 0.215 1.4 0.64 0.376 0.426 0.564 0.966 0.564 1.62s-0.245 1.195-0.737 1.62c-0.49 0.426-1.113 0.639-1.865 0.639h-0.933z",
			fill: "url(#b)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m40.052 75.166c0-3.188 2.584-5.772 5.773-5.772 3.188 0 5.773 2.584 5.773 5.772s-2.585 5.772-5.773 5.772c-3.189 0-5.773-2.584-5.773-5.772",
			fill: "#009CEA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m22.966 68.084c0-3.188 2.584-5.772 5.773-5.772 3.188 0 5.773 2.584 5.773 5.772s-2.585 5.772-5.773 5.772c-3.189 0-5.773-2.585-5.773-5.772",
			fill: "#009CEA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m15.873 50.998c0-3.188 2.584-5.772 5.773-5.772 3.188 0 5.773 2.584 5.773 5.772s-2.585 5.771-5.773 5.771c-3.189 1e-3 -5.773-2.583-5.773-5.771",
			fill: "#009CEA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m57.139 68.084c0-3.188 2.584-5.772 5.773-5.772 3.188 0 5.773 2.584 5.773 5.772s-2.585 5.772-5.773 5.772c-3.189 0-5.773-2.585-5.773-5.772",
			fill: "#009CEA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m22.966 33.912c0-3.188 2.584-5.773 5.773-5.773 3.188 0 5.773 2.585 5.773 5.773s-2.585 5.771-5.773 5.771c-3.189 1e-3 -5.773-2.583-5.773-5.771",
			fill: "#009CEA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 45.855,
			y: 21.062,
			width: 24.163,
			height: 11.539,
			fill: "#FFE133"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 64.232,
			y: 26.819,
			width: 11.542,
			height: 24.171,
			fill: "#FFE133"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m51.598 26.83c0 3.188-2.584 5.771-5.773 5.771-3.188 0-5.773-2.584-5.773-5.771 0-3.188 2.585-5.773 5.773-5.773 3.189 0 5.773 2.585 5.773 5.773",
			fill: "#1BE0BA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m75.777 50.998c0 3.188-2.584 5.771-5.773 5.771-3.188 0-5.773-2.584-5.773-5.771 0-3.188 2.585-5.772 5.773-5.772 3.189 0 5.773 2.584 5.773 5.772",
			fill: "#1BE0BA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			transform: "matrix(.7071 -.7071 .7071 .7071 -10.483 52.378)",
			x: 40.949,
			y: 33.077,
			width: 34.066,
			height: 11.531,
			fill: "#FFE133"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m51.598 50.998c0 3.188-2.584 5.771-5.773 5.771-3.188 0-5.773-2.584-5.773-5.771 0-3.188 2.585-5.772 5.773-5.772 3.189 0 5.773 2.584 5.773 5.772",
			fill: "#1BE0BA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m75.777 26.83c0 3.188-2.584 5.771-5.773 5.771-3.188 0-5.773-2.584-5.773-5.771 0-3.188 2.585-5.773 5.773-5.773 3.189 0 5.773 2.585 5.773 5.773",
			fill: "#1BE0BA"
		})
	]
});
export default SvgBilderitLogoHzColorCroppedDarkmode;
